import { render, staticRenderFns } from "./MeasureConfigEditor.vue?vue&type=template&id=1349c5df&scoped=true"
import script from "./MeasureConfigEditor.vue?vue&type=script&lang=js"
export * from "./MeasureConfigEditor.vue?vue&type=script&lang=js"
import style0 from "./MeasureConfigEditor.vue?vue&type=style&index=0&id=1349c5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349c5df",
  null
  
)

export default component.exports